import ScreenshotCarousel, { ScreenshotItem } from './ScreenshotCarousel';

const WebAdminScreenshotsGallery = () => {
  const screenshots: ScreenshotItem[] = [
    {
      src: '/screenshots/web-admin/admin-1.png',
      alt: 'Dashboard principal - Vue d\'ensemble',
      title: 'Étape 1 : Dashboard analytics',
      description: 'Accédez à une vue d\'ensemble complète de votre système de parking avec des métriques en temps réel. Suivez les revenus, le nombre de tickets actifs, la disponibilité des parkings et les statistiques clés de performance.',
      step: 'Vue d\'ensemble'
    },
    {
      src: '/screenshots/web-admin/admin-2.png',
      alt: 'Gestion des parkings',
      title: 'Étape 2 : Gestion des parkings',
      description: 'Gérez efficacement tous vos parkings depuis une interface centralisée. Créez, modifiez et configurez les zones de stationnement, définissez les tarifs horaires et suivez la disponibilité en temps réel.',
      step: 'Gestion des parkings'
    },
    {
      src: '/screenshots/web-admin/admin-3.png',
      alt: 'Suivi des tickets',
      title: 'Étape 3 : Suivi des tickets',
      description: 'Surveillez en temps réel tous les tickets de stationnement actifs et historiques. Filtrez par date, parking, utilisateur ou statut. Exportez les données pour vos analyses et rapports.',
      step: 'Suivi des tickets'
    },
    {
      src: '/screenshots/web-admin/admin-4.png',
      alt: 'Gestion des utilisateurs',
      title: 'Étape 4 : Gestion des utilisateurs',
      description: 'Administrez tous les comptes utilisateurs de votre plateforme. Consultez les profils, gérez les accès, visualisez l\'historique des transactions et intervenez si nécessaire pour un support optimal.',
      step: 'Gestion des utilisateurs'
    },
    {
      src: '/screenshots/web-admin/admin-5.png',
      alt: 'Configuration système',
      title: 'Étape 5 : Configuration système',
      description: 'Configurez tous les paramètres de votre plateforme : tarifs, notifications, intégrations, paramètres de paiement et bien plus. Personnalisez votre système selon vos besoins spécifiques.',
      step: 'Configuration système'
    },
  ];

  return (
    <ScreenshotCarousel
      screenshots={screenshots}
      variant="desktop"
      colorScheme={{
        badge: 'bg-purple-100 text-purple-800',
        activeBadge: 'bg-purple-600',
        border: 'border-purple-600',
        ring: 'ring-purple-200',
        indicator: 'bg-purple-600',
      }}
      thumbnailTitle="Parcours complet en 5 étapes"
      showThumbnails={false}
      autoplay={false}
    />
  );
};

export default WebAdminScreenshotsGallery;
